import { createSlice } from "@reduxjs/toolkit";
import { ApplicationData, CheckApplicationResponse } from "./Types";

type initialStateType = {
  applicationList: ApplicationData[];
  checkApplicationResponse: CheckApplicationResponse | null;
  checkApplicationID: string | null;
  status: {
    applicationListLoading: boolean;
    manageApplicationLoading: boolean;
    manageApplicationStatus: boolean;
    manageApplicationMessage: string;
    checkApplicationLoading: boolean;
    checkApplicationStatus: boolean;
    checkApplicationMessage: string;
    deleteApplicationLoading: boolean;
    deleteApplicationStatus: boolean;
    deleteApplicationMessage: string;
  };
};

var initialState: initialStateType = {
  applicationList: [],
  checkApplicationResponse: null,
  checkApplicationID: null,
  status: {
    applicationListLoading: false,
    manageApplicationLoading: false,
    manageApplicationStatus: false,
    manageApplicationMessage: "",
    checkApplicationLoading: false,
    checkApplicationStatus: false,
    checkApplicationMessage: "",
    deleteApplicationLoading: false,
    deleteApplicationStatus: false,
    deleteApplicationMessage: "",
  },
};

const manageApplicationSlice = createSlice({
  name: "manage-application",
  initialState: initialState,
  reducers: {
    setApplicationList: (state, action) => {
      state.applicationList = action.payload;
    },
    setApplicationListLoading: (state, action) => {
      state.status.applicationListLoading = action.payload;
    },
    setManageApplicationLoading: (state, action) => {
      state.status.manageApplicationLoading = action.payload;
    },
    setManageApplicationStatus: (state, action) => {
      state.status.manageApplicationStatus = action.payload;
    },
    setManageApplicationMessage: (state, action) => {
      state.status.manageApplicationMessage = action.payload;
    },
    setCheckApplicationResponse: (state, action) => {
      state.checkApplicationResponse = action.payload;
    },
    setCheckApplicationLoading: (state, action) => {
      state.status.checkApplicationLoading = action.payload;
    },
    setCheckApplicationStatus: (state, action) => {
      state.status.checkApplicationStatus = action.payload;
    },
    setCheckApplicationMessage: (state, action) => {
      state.status.checkApplicationMessage = action.payload;
    },
    setCheckApplicationID: (state, action) => {
      state.checkApplicationID = action.payload;
    },
    setDeleteApplicationLoading: (state, action) => {
      state.status.deleteApplicationLoading = action.payload;
    },
    setDeleteApplicationStatus: (state, action) => {
      state.status.deleteApplicationStatus = action.payload;
    },
    setDeleteApplicationMessage: (state, action) => {
      state.status.deleteApplicationMessage = action.payload;
    },
  },
});

export const manageApplicationSliceReducer = manageApplicationSlice.reducer;
export const manageApplicationSliceAction = manageApplicationSlice.actions; 